import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchCoordinators = async ({ coordinator, headUser, trialId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/patient/patient/get_coordinators/`, {
    params: { coordinator, head_user: headUser, trial: trialId },
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetCoordinators = ({ coordinator, headUser, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["coordinators", coordinator, headUser, trialId],
    queryFn: () => fetchCoordinators({ coordinator, headUser, trialId }),
    enabled: enabled && Boolean(coordinator) && Boolean(headUser) && Boolean(trialId),
  });
};

export default useGetCoordinators;
